'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates a random string to be used as a game seed.
 */
function generateSeed() {
    var charCodes = [];
    var numChars = Math.floor(Math.random() * 8 + 3);
    for (var i = 0; i < numChars; i++) {
        charCodes.push(Math.floor(Math.random() * 94 + 33));
    }
    return (String.fromCharCode.apply(String, charCodes));
}
exports.generateSeed = generateSeed;
//# sourceMappingURL=SetupUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/utils/SetupUtils.js
// module id = 33
// module chunks = 0